// extracted by mini-css-extract-plugin
export default {"tableWrapper":"DLu2g","table":"ebdEi","header":"UhdmY","headerCell":"lajpB","headerText":"O0wWz","body":"bCj9p","row":"SwMO1","updatedRow":"T5KFW","deletedRow":"Cn5Pd"};